export default __webpack_public_path__ + "a18d00fc679e1d09f1c1d295d39ce5ab.woff2";